import ChargeHelper from 'features/Charge/chargeHelper';
import SystemHelper from 'features/System/systemHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
    KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import MenuActionDropdown from 'general/components/Others/MenuActionDropdown';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import Global from 'general/utils/Global';
import Utils from 'general/utils/Utils';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import DialogAddTutorialView from '../DialogAddTutorialView';
import { AppDialogHelper } from 'general/components/AppDialog';
import ToastHelper from 'general/helpers/ToastHelper';
import AppResource from 'general/constants/AppResource';

TutorialListView.propTypes = {
    showFullUI: PropTypes.bool,
    prefKey: PropTypes.string,
};

const defaultColumnIds = [
    'OBJECT',
    'TITLE',
    'CONTENT',
    'LINK',
    'STATUS',
    'ORDER',
];

function TutorialListView({ showFullUI, prefKey }) {
    // MARK: ---- PROPERTIES ----
    const { t } = useTranslation();
    const { user } = useSelector((state) => state.auth);
    const isAdmin = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
    const [filter, setFilter] = useState(Global.g_filterTutorialsList);
    const [tutorialList, setTutorialList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [total, setTotal] = useState(0);
    useEffect(() => {
        handleGetTutorialList();
    }, [filter]);
    const handleGetTutorialList = () => {
        setIsLoading(true);
        const params = _.pickBy(
            filter,
            (value) => value !== null && value !== undefined && value !== ''
        );
        ChargeHelper.API.Tutorial.requestGetTutorialList(params)
            .then((response) => {
                setTutorialList(response?.tutorials);
                setTotal(response?.total);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }
    const fullColumns = useMemo(() => {
        return [
            {
                id: 'OBJECT',
                name: UIHelper.buildTableColumn('Đối tượng'),
                selector: (row) => row?.for ? t(`object_${row.for}`) : '',
                width: '100px',
            },
            {
                id: 'TITLE',
                name: UIHelper.buildTableColumn('Tiêu đề'),
                selector: (row) => {
                    return (
                        <KTTooltip text={row?.title}>
                            <div className="my-2 text-ellipsis-2-lines" style={{ whiteSpace: 'normal' }}>
                                {row?.title}
                            </div>
                        </KTTooltip>
                    );
                },
                minWidth: '300px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'CONTENT',
                name: UIHelper.buildTableColumn('Nội dung'),
                selector: (row) => {
                    return (
                        <div className="my-2 text-ellipsis-2-lines" style={{ whiteSpace: 'normal' }}>
                            {row?.content}
                        </div>
                    );
                },
                minWidth: '400px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'LINK',
                name: UIHelper.buildTableColumn('Đường dẫn video'),
                selector: (row) => row?.videoUrl,
                minWidth: '160px',
                style: tableStyle.columns.link,
            },
            {
                id: 'STATUS',
                name: UIHelper.buildTableColumn('Trạng thái'),
                selector: (row) => {
                    return (
                        <KTLabel
                            text={ChargeHelper.Utils.getTutorialStatusName(row?.status)}
                            isInline={true}
                            size={KTLabelSize.medium}
                            additionalClassName={`label-light-${ChargeHelper.Utils.getTutorialStatusColor(
                                row?.status
                            )}`}
                        />
                    );
                },
                width: '150px',
                style: tableStyle.columns.normal,
            },
            {
                id: 'ORDER',
                name: UIHelper.buildTableColumn('Thứ tự xuất hiện'),
                selector: (row) => row?.order,
                width: '130px',
                style: tableStyle.columns.normal,
            },
            {
                name: UIHelper.buildTableColumn('Thao tác'),
                maxWidth: '140px',
                style: {
                    position: 'sticky',
                    right: 0,
                    backgroundColor: '#fff',
                    borderLeft: '1px solid #ebedfe',
                },
                cell: (row) => {
                    return (
                        <MenuActionDropdown
                            menuAction={[
                                {
                                    iconElement: (
                                        <i
                                            className="fa-regular fa-pen-to-square"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: t('edit'),
                                    click: () => {
                                        handleAddNew(row);
                                    },
                                    show: true,
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-eye-slash"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: t('Ẩn'),
                                    click: () => {
                                        handleHideTutorial(row);
                                    },
                                    show: row?.status === 'NORMAL',
                                },
                                {
                                    iconElement: (
                                        <i
                                            className="far fa-eye"
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: t('Khôi phục'),
                                    click: () => {
                                        handleActiveTutorial(row);
                                    },
                                    show: row?.status === 'DELETED',
                                },
                                {
                                    iconElement: (
                                        <i
                                            className={`fa-regular fa-trash-can`}
                                            style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                        ></i>
                                    ),
                                    text: t('Xóa hướng dẫn sử dụng'),
                                    click: () => {
                                        handleDeleteTutorial(row);
                                    },
                                    show: true,
                                },
                            ]}
                        />
                    );
                },
            },
        ];
    }, [t]);
    const [fullColumnIds, setFullColumnIds] = useState(
        fullColumns?.map((row) => row?.id).filter(Boolean) || []
    );
    const {
        columnIds,
        columns,
        onChangeCheckboxValue,
        resetDefaultTableColumn,
        onSelectAll,
        onUnSelectAll,
        fullColumnsSorted,
        fullColumnsIdSorted,
        saveChanges,
    } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);

    // MARK: ---- METHODS ----
    const handleRefresh = (newFilter) => {
        setFilter(newFilter);
    };
    const handleAddNew = (row) => {
        AppCustomDialogHelper.show(
            !!row ? 'Sửa mẫu HDSD' : 'Thêm mẫu HDSD',
            <DialogAddTutorialView
                item={row}
                onCancel={() => AppCustomDialogHelper.hide()}
                onDone={() => {
                    AppCustomDialogHelper.hide();
                    handleRefresh({ ...filter });
                }}
            />,
            'lg',
            false,
            true
        );
    };
    // an HDSD
    const handleHideTutorial = (row) => {
        AppDialogHelper.show(
            'Ẩn hướng dẫn sử dụng',
            `Bạn có chắc muốn ẩn hướng dẫn sử dụng này không?`,
            [
                {
                    title: 'Hủy bỏ',
                    type: 'neutral',
                    onClick: () => {
                        AppDialogHelper.hide();
                    },
                },
                {
                    title: 'Ần',
                    type: 'negative',
                    onClick: async () => {
                        AppDialogHelper.hide();
                        const isSuccess = await ChargeHelper.API.Tutorial.requestUpdateTutorial(row?.tutorialId, {
                            status: 'DELETED',
                        });
                        if (isSuccess) {
                            ToastHelper.showSuccess(`Ẩn hướng dẫn sử dụng thành công`);
                            handleGetTutorialList();
                        } else {
                            ToastHelper.showError(`Ẩn hướng dẫn sử dụng không thành công`);
                        }
                    },
                },
            ],
            false,
            AppResource.images.dialogIcons.dialogStopAgency
        );
    }

    // khoi phuc HDSD
    const handleActiveTutorial = (row) => {
        AppDialogHelper.show(
            'Khôi phục hướng dẫn sử dụng',
            `Bạn có chắc muốn khôi phục hướng dẫn sử dụng này không?`,
            [
                {
                    title: 'Hủy bỏ',
                    type: 'neutral',
                    onClick: () => {
                        AppDialogHelper.hide();
                    },
                },
                {
                    title: 'Khôi phục',
                    type: 'success',
                    onClick: async () => {
                        AppDialogHelper.hide();
                        const isSuccess = await ChargeHelper.API.Tutorial.requestUpdateTutorial(row?.tutorialId, {
                            status: 'NORMAL',
                        });
                        if (isSuccess) {
                            ToastHelper.showSuccess(`Khôi phục hướng dẫn sử dụng thành công`);
                            handleGetTutorialList();
                        } else {
                            ToastHelper.showError(`Khôi phục hướng dẫn sử dụng không thành công`);
                        }
                    },
                },
            ],
            false,
            AppResource.images.dialogIcons.dialogActiveAgency
        );
    }

    //xoa HDSD
    const handleDeleteTutorial = (row) => {
        AppDialogHelper.show(
            `Xoá hướng dẫn sử dụng`,
            `Bạn thực sự muốn xoá hướng dẫn sử dụng này?`,
            [
                {
                    title: 'Hủy bỏ',
                    type: 'neutral',
                    onClick: () => {
                        AppDialogHelper.hide();
                    },
                },
                {
                    title: 'Xóa',
                    type: 'negative',
                    onClick: async () => {
                        AppDialogHelper.hide();
                        const isSuccess = await ChargeHelper.API.Tutorial.requestDeleteTutorial(row?.tutorialId);
                        if (isSuccess) {
                            ToastHelper.showSuccess(`Xoá hướng dẫn sử dụng thành công`);
                            handleGetTutorialList();
                        } else {
                            ToastHelper.showError(`Xóa hướng dẫn sử dụng thất bại`);
                        }
                    },
                },
            ],
            false,
            AppResource.images.dialogIcons.dialogDeleteVehicle
        );
    }

    return (
        <div>
            {UIHelper.buildCard(
                <div>
                    <div className="pb-4">
                        {/* header */}
                        <div className="px-4 pt-4 pb-4 d-flex align-items-center justify-content-between">
                            {/* title */}
                            <div className="d-flex flex-column">
                                <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                                    Cấu hình hướng dẫn sử dụng
                                </span>
                                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                    Tổng:{' '}
                                    <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                                        {Utils.formatNumber(total)} bản ghi
                                    </span>
                                </span>
                            </div>

                            {/* actions */}
                            {isAdmin &&
                                UIHelper.buildGreenButton(
                                    'Thêm mẫu hướng dẫn sử dụng',
                                    handleAddNew,
                                    <i className="fa-regular fa-circle-plus" />
                                )}
                        </div>

                        {/* table */}
                        <div>
                            {/* filter */}
                            <div className="row m-0 p-0 px-2">
                                {/* tim kiem */}
                                <div className="pl-2 pr-0 pr-md-4 col-xl-3 col-md-4 py-2">
                                    {UIHelper.buildFormLabel('Tìm kiếm')}
                                    <KTFormSearch
                                        name="search"
                                        placeholder="Theo tiêu đề..."
                                        value={filter.q}
                                        onSubmit={(text) => {
                                            Global.g_filterTutorialsList = {
                                                ...Global.g_filterTutorialsList,
                                                q: text,
                                                page: 0,
                                            };
                                            setFilter(Global.g_filterTutorialsList);
                                        }}
                                    />
                                </div>
                                {/* loc theo doi tuong */}
                                <div className="pl-0 pr-0 pr-md-4 col-xl-3 col-md-4 py-2">
                                    {UIHelper.buildFormLabel('Đối tượng')}
                                    <KTBSDropdown
                                        name="for"
                                        toggleElement={
                                            <button
                                                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between dropdown-disabled"
                                                type="button"
                                            >
                                                {_.find(
                                                    ChargeHelper.Data.tutorialObjectOptions,
                                                    (item) => item.value === filter.for
                                                )?.name ?? 'Tất cả'}
                                            </button>
                                        }
                                        selectedValue={filter.for}
                                        dropdownMenuItems={[
                                            { name: 'Tất cả', value: '' },
                                            ...ChargeHelper.Data.tutorialObjectOptions,
                                        ]}
                                        dropdownMenuClassName="overflow-auto w-100"
                                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                                        onChange={(value) => {
                                            Global.g_filterTutorialsList = {
                                                ...Global.g_filterTutorialsList,
                                                for: value,
                                                page: 0,
                                            };
                                            setFilter(Global.g_filterTutorialsList);
                                        }}
                                        isDropdownForm={true}
                                        disabled={true}
                                    />
                                </div>
                                {/* loc theo trang thai */}
                                <div className="pl-0 pr-0 pr-md-4 col-xl-3 col-md-4 py-2">
                                    {UIHelper.buildFormLabel('Trạng thái')}
                                    <KTBSDropdown
                                        name="status"
                                        toggleElement={
                                            <button
                                                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                                type="button"
                                            >
                                                {_.find(
                                                    ChargeHelper.Data.tutorialStatusOptions,
                                                    (item) => item.value === filter.status
                                                )?.name ?? 'Tất cả'}
                                            </button>
                                        }
                                        selectedValue={filter.status}
                                        dropdownMenuItems={[
                                            { name: 'Tất cả', value: '' },
                                            ...ChargeHelper.Data.tutorialStatusOptions,
                                        ]}
                                        dropdownMenuClassName="overflow-auto w-100"
                                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                                        onChange={(value) => {
                                            Global.g_filterTutorialsList = {
                                                ...Global.g_filterTutorialsList,
                                                status: value,
                                                page: 0,
                                            };
                                            setFilter(Global.g_filterTutorialsList);
                                        }}
                                        isDropdownForm={true}
                                    />
                                </div>
                            </div>

                            <div className="px-4 mt-4">
                                <KTTable
                                    columns={columns}
                                    items={tutorialList}
                                    selectableRows={false}
                                    striped={false}
                                    compactGrid={false}
                                    onClickedRow={(row) => { }}
                                    onSelectedRowsChanged={(rows) => { }}
                                    onDoubleClickedRow={(row) => { }}
                                    noDataComponent={UIHelper.buildEmptyNoData(
                                        'Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.'
                                    )}
                                />
                            </div>
                        </div>

                        {/* pagination */}
                        <div className="px-4 mt-2">
                            <KTPagination
                                currentPage={filter.page + 1}
                                rowCount={total}
                                rowsPerPage={filter.limit}
                                currentItemInPageCount={tutorialList?.length}
                                onChangePage={(newPage) => {
                                    const iNewPage = parseInt(newPage);
                                    Global.g_filterTutorialsList = {
                                        ...Global.g_filterTutorialsList,
                                        page: iNewPage - 1,
                                    };
                                    setFilter(Global.g_filterTutorialsList);
                                }}
                                onChangeRowsPerPage={(newRowsPerPage) => {
                                    const iNewRowsPerPage = parseInt(newRowsPerPage);
                                    Global.g_filterTutorialsList = {
                                        ...Global.g_filterTutorialsList,
                                        limit: iNewRowsPerPage,
                                        page: 0,
                                    };
                                    setFilter(Global.g_filterTutorialsList);
                                }}
                                loading={false}
                                color={KTPaginationColor.success}
                                appendText="bản ghi"
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default TutorialListView;
